export default __webpack_public_path__ + "static/media/cloud certi (1)_pages-to-jpg-0001.ae18e1e3.jpg";